import React from 'react';
import { AppBar, Toolbar, Tabs, Tab, Typography, AuthButton } from 'components';
import { withStyles, createStyleSheet } from 'material-ui/styles';

import { withRouter, NavLink } from 'react-router-dom';

const styleSheet = createStyleSheet('Header', () => ({
  title: {
    flex: 1,
    textDecoration: 'none',
  },
}));

class Header extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
    };
  }

  componentDidMount() {
    this.handleLocationChange();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.handleLocationChange();
    }
  }

  handleLocationChange = () => {
    const { pathname } = this.props.location;

    if (pathname === '/') {
      this.setState({ index: 0 }, this.changePath);
    }

    if (pathname === '/tools') {
      this.setState({ index: 1 }, this.changePath);
    }
  };

  handleTabChange = (event, index) => {
    this.setState({ index }, this.changePath);
  };

  changePath = () => {
    const { history } = this.props;
    const { index } = this.state;

    if (index === 0) {
      return history.push('/');
    }

    if (index === 1) {
      return history.push('/tools');
    }
  };

  render() {
    return (
      <AppBar color="primary">
        <Toolbar>
          <Typography
            type="title"
            color="inherit"
            className={this.props.classes.title}
            component={NavLink}
            to="/"
          >
            StackStack
          </Typography>
          <AuthButton color="contrast">로그인</AuthButton>
        </Toolbar>
        <Tabs centered index={this.state.index} onChange={this.handleTabChange}>
          <Tab label="Stacks" />
          <Tab label="Tools" />
        </Tabs>
      </AppBar>
    );
  }
}

export default withRouter(withStyles(styleSheet)(Header));



// WEBPACK FOOTER //
// ./src/App/Header.js